import React, { Component } from "react";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "jspdf-autotable";
import moment from "moment";
import DatePicker from "react-datetime";
import { imgData } from "../../../utils/Global";
import * as jsPDF from "jspdf";
import Select from "react-select";
import { getHeaders } from "../../../utils/apiHelper";
import {
  getMainRole,
  getFirstDayOfPrevMonth,
  getUserId,
  getInformation,
  print,
  fno,
  main_url,
  getBranch,
} from "../../../utils/CommonFunction";
import { EAM_Benefit_Status } from "./../../../utils/StatusData.js";
import DateTimeService from "../../../utils/dateTimeService.js";

const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

export default class BenefitChildTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: getUserId("user_info"),
      requestData: [],
      selectedRequest: "",
      is_main_role: getMainRole(),
      tab: this.props.tab,
      start_date: new Date(getFirstDayOfPrevMonth()),
      end_date: new Date(),
      pending_approve: "allrequest",
      dataList: [],
      branch: [], // Added by STHA
      eam_status_list: [], //Added by STHA
      selected_status: {
        label: "All",
        value: -1,
      }, //Added by STHA
      loading: false,
    };
  }
  componentDidMount() {
    this.getAllBranch(); //Added by STHA
    this.handleSearchData();
  }

  setActionsToTableBtn() {
    this.$el = $(this.el);

    // this.setState({
    //     requestData: this.state.requestData
    // }, () => {
    //     this._setTableData(this.state.dataList)
    // });

    let that = this;
    $("#dataTables-table").on("click", "#toView", function () {
      var data = $(this).find("#view").text();
      data = $.parseJSON(data);
      that.props.goToViewForm(data);
    });

    $("#dataTables-table").on("click", "#toEdit", function () {
      var data = $(this).find("#edit").text();
      data = $.parseJSON(data);

      that.props.goToEditForm(data);
    });

    $("#dataTables-table").on("click", "#toPrint", function () {
      var data = $(this).find("#print").text();
      data = $.parseJSON(data);
      that.getPrintData(data);
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tab != this.props.tab) {
      this.setState(
        {
          tab: this.props.tab,
        },
        () => this.filter()
      );
    }
  }

  //Added By STHA
  getAllBranch = async () => {
    const branches = await getBranch();
    this.setState({
      branch: branches,
      eam_status_list: EAM_Benefit_Status,
    });
  };

  //Added By STHA
  filterBranchByID(id, branch) {
    let selected = branch.filter((b) => {
      return b.value === id;
    });
    return selected.length > 0 ? selected[0].label : "--";
  }

  //Added by STHA
  handleSearchStatus = (event) => {
    this.setState({
      selected_status: event,
    });
  };

  getRequest() {
    this.search(0);
  }

  getCheck() {
    this.search(1);
  }

  getVerified() {
    this.search(2);
  }
  getApprove() {
    this.search(3);
  }
  getReject() {
    this.search(4);
  }
  getPendingForPayment() {
    this.search(22);
  }

  handleStartDate = async (event) => {
    this.setState({
      start_date: event,
    });
  };
  handleEndDate = async (event) => {
    this.setState({
      end_date: event,
    });
  };
  search(status) {
    let data = this.state.dataList;
    data = data.filter((d) => {
      return status === d.status;
    });
    this._setTableData(data);
  }
  approvedlist = async (data) => {
    if (data == "myrequest") {
      this.setState(
        {
          data: this.state.dataList.filter(
            (v) => v.user_id == this.state.user_id
          ),
          pending_approve: "myrequest",
        },
        () => {
          this._setTableData(this.state.data);
        }
      );
    } else {
      this.setState(
        {
          data: this.state.dataList.filter(
            (v) => v.user_id != this.state.user_id
          ),
          pending_approve: "allrequest",
        },
        () => {
          this._setTableData(this.state.data);
        }
      );
    }
  };
  handleSearchData = async () => {
    this.setState({
      loading: true,
    });
    let id = this.state.user_id;
    let status = this.state.selected_status.value;
    console.log("Here is status ", status);

    // fetch(main_url + "external_benefit/getExternalBenefit/" + id)

    let fetchURL = `${main_url}external_benefit/getExternalBenefit/${id}/${moment(
      this.state.start_date
    ).format("YYYY-MM-DD")}/${moment(this.state.end_date).format(
      "YYYY-MM-DD"
    )}/${status}`;

    fetch(fetchURL, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        if (this.state.pending_approve == "myrequest") {
          this.setState(
            {
              dataList: list,
              data: list.filter((v) => v.user_id == this.state.user_id),
              loading: false,
            },
            () => {
              this._setTableData(this.state.data);
            }
          );
        } else if (this.state.pending_approve == "allrequest") {
          this.setState(
            {
              dataList: list,
              data: list.filter((v) => v.user_id != this.state.user_id),
              loading: false,
            },
            () => {
              this._setTableData(this.state.data);
            }
          );
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  };

  filter() {
    if (this.props.tab == 0) {
      this.getAllBenefits();
    } else if (this.props.tab == 1) {
      this.getMyBenefits();
    }
  }

  async getPrintData(data) {
    var info = await getInformation(
      "external_benefit",
      data.external_training_id
    );
    var doc = new jsPDF("p", "mm", "a4");
    var col = [
      "Training Name",
      "Date Of Training",
      "Training Period",
      "Amount",
    ];
    var rows = [];
    var today = moment(Date.now()).format("YYYY-MM-DD");
    var temp = [
      data.training_name,
      data.training_date,
      data.training_period,
      data.approve_amount,
    ];
    rows.push(temp);
    doc.setFontSize(12);
    doc.addImage(imgData, "image/jpeg", 10, 10, 50, 15);
    doc.text("HR_0020 V2", 150, 15);
    doc.text("Benefit Request Form", 150, 25);
    doc.text("Generate Date: " + today, 13, 33);
    doc.text("Voucher No: " + fno.fno_external + data.form_no, 150, 40);
    doc.text(
      "Withdrawal Location: " +
        this.filterBranchByID(data.withdraw_location, this.state.branch),
      13,
      40
    );
    doc.autoTable(col, rows, { startY: 55 });
    if (doc.previousAutoTable.finalY > 220) {
      doc.addPage();
      doc.previousAutoTable.finalY = 0;
    }
    doc.setFontSize(10);
    doc.setFontType("bold");
    doc.text("Request By", 13, doc.previousAutoTable.finalY + 17);
    doc.text("Check By", 65, doc.previousAutoTable.finalY + 17);
    doc.text("Verify By", 114, doc.previousAutoTable.finalY + 17);
    doc.text("Approve By", 164, doc.previousAutoTable.finalY + 17);
    doc.setFontSize(9);
    doc.setFontType("normal");
    doc.text(
      info.requested.requested_date,
      13,
      doc.previousAutoTable.finalY + 25
    );
    doc.text(
      info.requested.employment_id,
      13,
      doc.previousAutoTable.finalY + 30
    );
    doc.text(
      info.requested.requested_by,
      13,
      doc.previousAutoTable.finalY + 35
    );
    doc.text(info.requested.branch_name, 13, doc.previousAutoTable.finalY + 40);
    doc.text(
      info.requested.designations,
      13,
      doc.previousAutoTable.finalY + 45
    );
    doc.text(info.checked.checked_date, 65, doc.previousAutoTable.finalY + 25);
    doc.text(info.checked.employment_id, 65, doc.previousAutoTable.finalY + 30);
    doc.text(info.checked.checked_by, 65, doc.previousAutoTable.finalY + 35);
    doc.text(info.checked.branch_name, 65, doc.previousAutoTable.finalY + 40);
    doc.text(info.checked.designations, 65, doc.previousAutoTable.finalY + 45);
    doc.text(
      info.verified.verified_date,
      114,
      doc.previousAutoTable.finalY + 25
    );
    doc.text(
      info.verified.employment_id,
      114,
      doc.previousAutoTable.finalY + 30
    );
    doc.text(info.verified.verified_by, 114, doc.previousAutoTable.finalY + 35);
    doc.text(info.verified.branch_name, 114, doc.previousAutoTable.finalY + 40);
    doc.text(
      info.verified.designations,
      114,
      doc.previousAutoTable.finalY + 45
    );
    doc.text(
      info.approved.approved_date,
      164,
      doc.previousAutoTable.finalY + 25
    );
    doc.text(
      info.approved.employment_id,
      164,
      doc.previousAutoTable.finalY + 30
    );
    doc.text(info.approved.approved_by, 164, doc.previousAutoTable.finalY + 35);
    doc.text(info.approved.branch_name, 164, doc.previousAutoTable.finalY + 40);
    doc.text(
      info.approved.designations,
      164,
      doc.previousAutoTable.finalY + 45
    );
    // doc.save('External Training Benefit.pdf');
    print(doc, data);
  }

  _setTableData = (data) => {
    var table;
    var l = [];
    var status;
    var permission = this.props.permission;
    var has_action =
      permission.isView === 1 || permission.isEdit === 1 ? true : false;
    if (data) {
      for (var i = 0; i < data.length; i++) {
        let result = data[i];
        let obj = [];
        if (result.status === 0) {
          status =
            '<small class="label label-warning" style="background-color:#509aed"> Request </small>';
        } else if (result.status === 1) {
          status =
            '<small class="label label-warning" style="background-color:#b33ce0"> Check  </small>';
        } else if (result.status === 2) {
          status =
            '<small class="label label-warning" style="background-color:#f2a509"> Verify  </small>';
        } else if (result.status === 3) {
          status =
            '<small class="label label-warning" style="background-color:#29a50a"> Approve  </small>';
        } else if (result.status === 4) {
          status =
            '<small class="label label-warning" style="background-color:#f60e2f"> Reject  </small>';
        } else if (result.status === 5) {
          status =
            '<small class="label label-warning" style="background-color:#cc0066"> ReferBack </small>';
        }
        //Added by STHA
        else if (result.status === 22) {
          status =
            '<small class="label label-warning" style="background-color:#db26de"> Pending For Payment </small>';
        } else if (result.status === 27) {
          status =
            '<small class="label label-warning" style="background-color:#ed5565"> Payment Reject </small>';
        } else if (result.status === 18) {
          status =
            '<small class="label label-warning" style="background-color:#c9a812"> Payment Approve </small>';
        } else if (result.status === 19) {
          status =
            '<small class="label label-warning" style="background-color:#4ab510"> Payment Receive </small>';
        } else if (result.status === 25) {
          status =
            '<small class="label label-warning" style="background-color:#008A5F"> Payment Finish </small>';
        } else if (result.status === 28) {
          status =
            '<small class="label label-warning" style="background-color:#cc0066"> Payment Refer Back </small>';
        } else if (result.status === 31) {
          status =
            '<small class="label label-warning" style="background-color:#cc0080"> Payment Receive Refer Back </small>';
        }

        obj = {
          no: i + 1,
          form_no: fno.fno_external + data[i].form_no,
          employee_id: data[i].employment_id,
          employee_name: data[i].fullname,
          position: data[i].designations ? data[i].designations : "-",
          branch: data[i].branch_name,
          training_type: data[i].training_name,
          // available_amount: data[i].available_amount,
          date_of_training: data[i].training_date,
          training_period: data[i].training_period,
          request_amount: data[i].request_amount,
          approve_amount: data[i].approve_amount,
          date: result.createdAt
            ? new DateTimeService(result.createdAt).formatDate
            : "-",
          status: status,
        };
        if (has_action) {
          if (
            result.status === 0 ||
            result.status === 1 ||
            result.status === 2 ||
            result.status === 4 ||
            result.status === 5 ||
            result.status === 28
          ) {
            obj.action =
              permission.isView === 1
                ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toView" ><span id="view" class="hidden" >' +
                  JSON.stringify(result) +
                  '</span>  <i className="fa fa-cogs"></i>&nbsp;View</button>'
                : "";
            obj.action +=
              permission.isEdit === 1 ||
              (result.status == 5 && data[i].createdBy == this.state.user_id)
                ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toEdit" ><span id="edit" class="hidden" >' +
                  JSON.stringify(result) +
                  '</span>  <i className="fa fa-cogs"></i>&nbsp;Edit</button>'
                : "";
          } else {
            obj.action =
              permission.isView === 1
                ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toView" ><span id="view" class="hidden" >' +
                  JSON.stringify(result) +
                  '</span>  <i className="fa fa-cogs"></i>&nbsp;View</button>'
                : "";

            if (result.print === 1) {
              obj.action +=
                '<button style="margin-right:10px" class="btn btn-info btn-sm own-btn-edit" id="toPrint" ><span id="print" class="hidden" >' +
                JSON.stringify(result) +
                '</span>  <i className="fa fa-cogs"></i>&nbsp;Printed</button>';
            } else {
              obj.action +=
                '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toPrint" ><span id="print" class="hidden" >' +
                JSON.stringify(result) +
                '</span>  <i className="fa fa-cogs"></i>&nbsp;Print</button>';
            }
          }
        }

        l.push(obj);
      }
    }
    // this.setState({
    //     dataSource: l,

    // });
    if ($.fn.dataTable.isDataTable("#dataTables-table")) {
      table = $("#dataTables-table").dataTable();
      table.fnClearTable();
      table.fnDestroy();
      $("#dataTables-table").empty();
    }

    var column = [
      { title: "No", data: "no" },
      { title: "Form No", data: "form_no" },
      { title: "Employee Id", data: "employee_id" },
      { title: "Employee Name", data: "employee_name" },
      { title: "Position", data: "position" },
      { title: "Branch", data: "branch" },
      { title: "Training Type", data: "training_type" },
      { title: "Date of Training", data: "date_of_training" },
      { title: "Training Period", data: "training_period" },
      { title: "Request Amount", data: "request_amount" },
      { title: "Approve Amount", data: "approve_amount" },
      { title: "Date", data: "date" },
      { title: "Status", data: "status" },
    ];

    if (has_action) {
      column.push({ title: "Action", data: "action" });
    }

    table = $("#dataTables-table").DataTable({
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      pageLength: 50,
      paging: true,
      // buttons: true,
      dom: "Bfrtip",
      // buttons: [
      //     'copy', 'csv', 'excel', 'pdf'
      // ],
      buttons: [
        "copy",
        {
          extend: "csvHtml5",
          title: "External Training",
        },
        {
          extend: "excelHtml5",
          title: "External Training",
        },
        {
          extend: "pdfHtml5",
          title: "External Training",
        },
      ],
      data: l,
      columns: column,
    });
    this.setActionsToTableBtn();
  };

  render() {
    return (
      <div>
        {this.state.loading && (
          <div
            className="loadingContainer col-lg-12 "
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <h1 className="fadingLoading">Loading...</h1>
          </div>
        )}
        {!this.state.loading && (
          <div>
            <div>
              <ul className="nav nav-tabs tab" role="tablist" id="tab-pane">
                <li className="nav-item">
                  <a
                    className="nav-link "
                    href="#wedding_benefit"
                    role="tab"
                    data-toggle="tab"
                    aria-selected="true"
                    onClick={() => this.approvedlist("myrequest")}
                  >
                    My Request
                  </a>
                </li>
                <li className="nav-item1 active">
                  <a
                    className="nav-link active"
                    href="#wedding_benefit"
                    role="tab"
                    data-toggle="tab"
                    onClick={() => this.approvedlist("allrequest")}
                  >
                    All Request
                  </a>
                </li>
              </ul>
            </div>
            <div
              className="row mt-2"
              style={{ display: "flex", alignItems: "end" }}
            >
              <div className="col-md-2">
                <label htmlFor="">Start Date</label>
                <DatePicker
                  dateFormat="DD/MM/YYYY"
                  value={this.state.start_date}
                  onChange={this.handleStartDate}
                  timeFormat={false}
                />
              </div>
              <div className="col-md-2">
                <label htmlFor="">End Date</label>
                <DatePicker
                  dateFormat="DD/MM/YYYY"
                  value={this.state.end_date}
                  onChange={this.handleEndDate}
                  timeFormat={false}
                />
              </div>

              {/* Added by STHA  */}
              <div className="col-md-3">
                <div>
                  <label className="col-sm-12">Payment Status</label>
                </div>
                <div className="col-md-10">
                  <Select
                    options={this.state.eam_status_list}
                    value={this.state.selected_status}
                    onChange={this.handleSearchStatus}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              {/* Added end STHA  */}

              <div className="col-md-2">
                <button
                  className="btn btn-primary text-center"
                  style={{
                    marginLeft: 10,
                    height: 30,
                    padding: "0px 5px 0px 5px",
                  }}
                  onClick={() => this.handleSearchData()}
                >
                  Search
                </button>
              </div>
            </div>
            <br />
            <div className="row">
              <div class="btn-group-g ">
                <button
                  type="button"
                  class="btn label-request g"
                  onClick={this.getRequest.bind(this)}
                >
                  Request
                </button>
                <button
                  type="button"
                  class=" btn label-check g"
                  onClick={this.getCheck.bind(this)}
                >
                  Check
                </button>
                <button
                  type="button"
                  class="btn label-verified g"
                  onClick={this.getVerified.bind(this)}
                >
                  Verify
                </button>
                {/* <button
                  type="button"
                  class="btn label-approve g"
                  onClick={this.getApprove.bind(this)}
                >
                  Approve
                </button> */}

                <button
                  type="button"
                  className="btn label-pending-for-payment g"
                  onClick={this.getPendingForPayment.bind(this)}
                >
                  Pending For Payment
                </button>

                <button
                  type="button"
                  class="btn label-reject g"
                  onClick={this.getReject.bind(this)}
                >
                  Reject
                </button>
              </div>
            </div>
            <table
              width="99%"
              className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive"
              id="dataTables-table"
            />
          </div>
        )}
      </div>
    );
  }
}
